/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  ShopifyAPI.fetchCart(window.buildCart);
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    //alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/

ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {
  console.log('ShopifyAPI.addItemFromForm');
  var $body = $(document.body);

  // Add-on detection from DY Shadow Root
  var shadowRootHost = document.querySelector('[data-dy-embedded-object]');
  var addonSelected = false;
  var addonProductId = null;

  if (shadowRootHost && shadowRootHost.shadowRoot) {
    var addonCheckbox = shadowRootHost.shadowRoot.querySelector('.addon__check');
    if (addonCheckbox && addonCheckbox.checked) {
      addonSelected = true;
      addonProductId = addonCheckbox.value;
    }
  }

  // Define function to add product to cart
  function customAddToCart(data, onSuccess, onError) {
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: onSuccess,
      error: onError
    });
  }

  // Trigger before add event
  $body.trigger('beforeAddItem.ajaxCart', form);

  // Add main product
  customAddToCart(jQuery(form).serialize(), function (mainLineItem) {
    // Push to GTM
    pushAddedItemDataToGTM(mainLineItem);

    // Add-on logic
    if (addonSelected && addonProductId) {
      customAddToCart({ id: addonProductId, quantity: 1 }, function (addonLineItem) {
        console.log('Add-on added to cart:', addonLineItem);
        if (typeof callback === 'function') {
          callback([mainLineItem, addonLineItem], form);
        } else {
          ShopifyAPI.onItemAdded(mainLineItem, form);
        }
        $body.trigger('afterAddItem.ajaxCart', [[mainLineItem, addonLineItem], form]);
        // Set flag to open cart drawer when item is added
        window.shouldOpenCartDrawer = true;
        setTimeout(() => $('body').addClass('ctm_mini_cart_active'), 500);
      }, function (err) {
        console.error('Error adding add-on:', err);
        if (typeof errorCallback === 'function') errorCallback(err);
        $body.trigger('errorAddItem.ajaxCart', [err]);
      });
    } else {
      if (typeof callback === 'function') {
        callback(mainLineItem, form);
      } else {
        ShopifyAPI.onItemAdded(mainLineItem, form);
      }
      $body.trigger('afterAddItem.ajaxCart', [mainLineItem, form]);
      // Set flag to open cart drawer when item is added
      window.shouldOpenCartDrawer = true;
      setTimeout(() => $('body').addClass('ctm_mini_cart_active'), 500);
    }
  }, function (err) {
    if (typeof errorCallback === 'function') errorCallback(err);
    else ShopifyAPI.onError(err);
    $body.trigger('errorAddItem.ajaxCart', [err]);
  });

  // Trigger complete
  $body.trigger('completeAddItem.ajaxCart', [form]);
};



// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function (callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  if (typeof callback === 'undefined') {
    return; // Exit function early if callback is not provided
  }
  
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = async function (line, quantity, callback, plusOrMinus) {
  var $body = $(document.body);
  
  try {
    // Trigger before change event
    $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    
    // Create form data
    const formData = new FormData();
    formData.append('quantity', quantity);
    formData.append('line', line);
    
    // Make the fetch request
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      body: formData
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const cart = await response.json();
    
    // Send updated quantity data to GTM
    sendUpdatedQtyDataToGTM(line, cart, plusOrMinus);
    
    // Execute callback
    if ((typeof callback) === 'function') {
      callback(cart);
    } else {
      ShopifyAPI.onCartUpdate(cart);
    }
    
    // Trigger after change event
    $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart, plusOrMinus]);
    
  } catch (error) {
    console.error('Error changing cart item:', error);
    $body.trigger('errorChangeItem.ajaxCart', [error, 'error']);
    ShopifyAPI.onError({ responseText: JSON.stringify({ message: error.message }) }, 'error');
  } finally {
    // Trigger complete event
    $body.trigger('completeChangeItem.ajaxCart', [{ url: '/cart/change.js' }, null, 'success']);
  }
};

// Fetch Cart Data
ShopifyAPI.fetchCart = function(successCB, errorCB){
  fetch('/cart?view=json').then(function(res){
    return res.json();
  }).then(function(cart){
    if(successCB && typeof successCB === 'function'){
      successCB(cart);
    }
  }).catch(function(err){
    if(errorCB && typeof errorCB === 'function'){
      errorCB(err);
    }
  })

  const body = document.querySelector('body');
  if (body.classList.contains('drawer-updating')) {
    setTimeout(() => {
      body.classList.remove('drawer-updating');
    }, 1000)
  }
}

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, setupCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    window.money_format = settings.moneyFormat;
    
    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
      window.customATCFlag = true;
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
      $('.js-drawer-open-right #CartCount,.js-drawer-open-right #CartCount2').html(cart.item_count).removeClass('hidden-count');
      $('.header__cart .c-hide').show();

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
        $('.js-drawer-open-right #CartCount,.js-drawer-open-right #CartCount2').addClass('hidden-count');
        $('.header__cart .c-hide').hide();
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify?.formatMoney ? Shopify.formatMoney(cart.total_price, settings.moneyFormat) : `$${cart.total_price}`);
    }
  };

 formOverride = function () {
  $addToCart.unbind('click').on('click', function (evt) {
    evt.preventDefault();
    const $button = $(this);
    const isLimitTrue = $button.parent().attr("data-product-limit");
    const productId = $button.parent().attr("data-product-id");

    if (isLimitTrue === 'false') {
      processForm($button); // No limit, proceed immediately
      return;
    }

    // Function to get the add-on checkbox from shadow DOM
    function getAddonCheckbox() {
      let embeddedObject = document.querySelector("#AddToCartForm [data-dy-embedded-object='true']");
      if (embeddedObject && embeddedObject.shadowRoot) {
        return embeddedObject.shadowRoot.querySelector(".addon__product input.addon__check");
      }
      return null;
    }

    const addonCheckbox = getAddonCheckbox();

    if (addonCheckbox && addonCheckbox.value) {
      let wasCheckboxInteractedWith = false;

      // Mutation observer to check when the value is cleared
      const observer = new MutationObserver(() => {
        wasCheckboxInteractedWith = true; // Mark as interacted
        if (!addonCheckbox.value) { // Value is cleared by app
          observer.disconnect(); // Stop observing
          checkCartAndProceed($button, productId);
        }
      });

      // Start observing the `value` attribute for changes
      observer.observe(addonCheckbox, { attributes: true, attributeFilter: ["value"] });

      // If the checkbox has a value but user never interacts, don't wait forever
      setTimeout(() => {
        if (!wasCheckboxInteractedWith) {
          observer.disconnect(); // Stop observing
          checkCartAndProceed($button, productId);
        }
      }, 2000); // Give time for app to update if needed

    } else {
      // If no add-on product is selected, proceed normally
      checkCartAndProceed($button, productId);
    }
  });
};

  const checkCartAndProceed = function ($button, productId) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const itemExists = cart.items.some(item => item.product_id === +productId);
        let errorMessageElement = document.querySelector('.limit-quantity-error');

        if (itemExists) {
          if (errorMessageElement) {
            errorMessageElement.classList.add('show');
            setTimeout(() => {
              errorMessageElement.classList.remove('show');
            }, 5000);
          }
        } else {
          processForm($button); // Add product to cart after app's add.js completes
        }
      })
      .catch(error => {
        console.error('Error checking cart:', error.message);
      });
  };

  const processForm = function ($button) {
    $button.removeClass('is-added').addClass('is-adding');
    $('.qty-error').remove();
    
    var form = $button.closest('form');
    var variantId = jQuery(form).find('input[name="id"]:checked').val();
    
    if (!variantId) {
      jQuery('.error-state').removeClass('hide');
      return false;
    }

    $button.text(window.Theme.strings.product.addingToCart);
    
    ShopifyAPI.addItemFromForm(form, itemAddedCallback, itemErrorCallback);
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');
    // Set flag to open cart drawer when item is added
    window.shouldOpenCartDrawer = true;
    ShopifyAPI.getCart(cartUpdateCallback);
    $addToCart.text(window.Theme.strings.product.addedToCart);
    setTimeout(function() {
      $addToCart.text(window.Theme.strings.product.addToCart);
    }, 2000);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>');
        $addToCart.text(window.Theme.strings.product.addToCart);
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  
  setupCart = function(cartjson){
    // Start with a fresh cart div
    console.log('cartjson',cartjson);
    var cart = cartjson.cart ? cartjson.cart : cartjson;
    var cart_items = cartjson.items ? cartjson.items : [];
   
    if (cart.item_count === 0) {
      if (window.Theme.customer.firstName) {
        $cartContainer.parents('#CartDrawer').find('.drawer__header .cart__qty').text("(" + cart.item_count + ")");
        $cartContainer.parents('#CartDrawer').find('.drawer__header .cart-text').text(window.Theme.customer.welcomeBackEmpty);
      } else {
        $cartContainer.parents('#CartDrawer').find('.drawer__header .cart__qty').text("(" + cart.item_count + ")");
        $cartContainer.parents('#CartDrawer').find('.drawer__header .cart-text').text("Your basket is currently empty.");
    }
      $cartContainer.html('<a class="shop-new" href="/collections/new-in">Shop New Arrivals</a>');
      cartCallback(cart);
      return;
    }

    $cartContainer.parents('#CartDrawer').find('.drawer__header .cart__qty').text("(" + cart.item_count + ")");

    if (window.Theme.customer.firstName) {
      $cartContainer.parents('#CartDrawer').find('.drawer__header .cart-text').text(window.Theme.customer.welcomeBack);
    } else {
      $cartContainer.parents('#CartDrawer').find('.drawer__header .cart-text').text("Welcome back! We saved your basket for you!");
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      //console.log(cartItem);
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      var inv_qty = cart_items.filter(function(c_i){
        return c_i.id === cartItem.id;
      })[0];

      $.getJSON('/products/'+cartItem.handle+'.js',function(product){
        // console.log(product);
        var tag_len = product.tags.length;
        var tags = product.tags;
        for(var i = 0; i < tag_len; i++){
          if(tags[i] == 'limit-quantity' || tags[i] == 'Limit-quantity' || tags[i] == 'Limit-Quantity'){
            console.log('demo 123456');
            $('.ajaxcart__row[data-id="'+product.id+'"] .ajaxcart__qty .ajaxcart__qty--plus').hide();
            $('.ajaxcart__row[data-id="'+product.id+'"] .ajaxcart__qty .ctm_plus_btn').show();
            $('.ajaxcart__row[data-id="'+product.id+'"] .ajaxcart__qty .ajaxcart__qty-num').addClass('ctm_disabled');
          }
        }
      })
      var hasonsale=false,hasNoISPU=false,hasReleaseProduct=false,finalSaleTag;
      if(cart_items[index].product!=undefined){
        if(cart_items[index].product.tags.some(x => x.toLowerCase() == 'on-sale')){
          hasonsale=true;
        }
        if(cart_items[index].product.tags.some(x => x.toLowerCase() == 'final-sale')){
          hasReleaseProduct=true;
        }
        if(cart_items[index].product.tags.some(x => x.toLowerCase() == 'no-ispu')){
          hasNoISPU=true;
        }
        if(hasReleaseProduct && hasNoISPU ){
          finalSaleTag = cart_both;
        }else{
          if (hasonsale){
            finalSaleTag = cart_onSale;
          }else if(hasReleaseProduct){
            finalSaleTag = cart_finalSale;
          }else if(hasNoISPU){
            finalSaleTag = cart_noIspu;
          }
        }
      }

      const getVariantSubtitle = (cartItem) => {
      const variantTitle = cartItem?.variant_title;
      if (typeof variantTitle === 'string') {
        const parts = variantTitle.split(/\/(.+)/);
        return parts[1]?.trim() || '';
      }
        return '';
      }
      const lastPart = getVariantSubtitle(cartItem);
      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        id: cartItem.product_id,
        img: prodImg,
        name: cartItem.product_title,
        variation: lastPart,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(cartItem.final_price, settings.moneyFormat),
        originalLinePrice: cart_items[index].product.compare_at_price ? Shopify.formatMoney(cart_items[index].product.compare_at_price, settings.moneyFormat) : '',
        discounts: cartItem.discounts,
        discountsApplied: cartItem.final_price === cartItem.original_price ? false : true,
        inv_qty: inv_qty.inventory_quantity,
        final_sale: finalSaleTag,
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : "You're saving [savings]".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true
    };
    
    $cartContainer.html(template(data));
    
    cartCallback(cart);
    $('.ctm_plus_btn').on('click',function(e){
      e.preventDefault();
      $(this).parents('.ajaxcart__product').find('.errors-row .limitation_msg').remove();
      $(this).parents('.ajaxcart__product').find('.errors-row').append(`<span class="ajaxcart__product-meta final-sale limitation_msg">"Sorry! Only 1 of these items can be added per customer. More units cannot be added to your basket."</span>`);
      var _this = $(this);
      setTimeout(function(e){
        _this.closest('.ajaxcart__row').find('.limitation_msg').remove();
      },5000)
      return false;
    })
    $('.js-drawer-open-right #CartCount,.js-drawer-open-right #CartCount2,#drawer-counter').text(cart.item_count);

  };
  
  buildCart = function (cart) {
    ShopifyAPI.fetchCart(function(cartjson){
      setupCart(cartjson);
    }, function(err){
      setupCart(cart);
    });
  };
  
  window.buildCart = buildCart ;

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Remove product from cart
    $body.on('click', '.ajaxcart__remove', async function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = 0;

      // If it has a data-line, update the cart
      if (line) {
        await updateQuantity(line, qty);
      }
    });

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', async function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);
      let plusOrMinus = 'plus';

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        plusOrMinus = 'minus'
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      var $parent = $el.closest('.ajaxcart__product');
      var maxQty = $parent.data('maxqty');
      if(qty > maxQty){
        $parent.find('.error-msg').removeClass('hide');
        return;
      } else {
        $parent.find('.error-msg').addClass('hide');
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        await updateQuantity(line, qty, plusOrMinus);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', async function() {
      if (isUpdating) {
        return; 
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        await updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    async function updateQuantity(line, qty, plusOrMinus) {
      isUpdating = true;
      
      $cartContainer.addClass('cart-loading');

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }
      
      $body.addClass('drawer-updating');
      
      // Slight delay to make sure removed animation is done
      try {
        await ShopifyAPI.changeItem(line, qty, adjustCartCallback, plusOrMinus);
        // debugger;
        $cartContainer.removeClass('cart-loading');
        } catch (error) {
          console.error('Error updating quantity:', error);
          // Reset updating state on error
          isUpdating = false;
          $cartContainer.removeClass('cart-loading');
          $body.removeClass('drawer-updating');
          $row.removeClass('is-loading');
          $row.parent().removeClass('is-removed');
        }
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      $body.removeClass('drawer-updating'); // Fix: Remove drawer-updating class
      // Ensure cart loading class is removed to allow further interactions
      // $cartContainer.removeClass('cart-loading');
      ShopifyAPI.fetchCart(buildCart);
    }, 120)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

//   $(document).on('click','.collection_product_wrapper .add_to_cart_wrapper a',function(e){
//     e.preventDefault();
//     var id = $(this).data('id');
//     console.log(id,'test');
//     var _this = $(this);
//     $.ajax({
//       method: "post",
//       url: "/cart/add.js",
//       data: "quantity=1&id="+id,
//       dataType: "json",
//       success: function(success){
//         console.log(success)
//         $.getJSON('/cart.js',function(cart){
//           buildCart(cart);
//         })
//       },
//       error: function(err){
//         console.log(err);
//         _this.closest('.add_to_cart_wrapper').find('.err').remove();
//         _this.closest('.add_to_cart_wrapper').append('<span class="err">Maximum quantity reached.</span>');
//         setTimeout(function(e){
//           _this.closest('.add_to_cart_wrapper').find('.err').remove();
//         },3000)
//       }
//     })
//   })
  
  return module;
  
}(ajaxCart || {}, jQuery));

// Added to bottom of ajax-cart.js.liquid
// Call pushAddedItemDataToGTM(line_item) on ShopifyAPI.addItemFromForm success

// When product is added to cart, send data to GTM

const pushAddedItemDataToGTM = (data) => {
  	console.log('pushAddedItemDataToGTM');
    let fetchPath = '/products/' + data.handle;
    if (data.url.includes('?variant=')) {
        fetchPath = data.url.split("?variant=")[0];
    }
    let itemName = data.product_title.toLowerCase();
    let itemSku = data.sku.toLowerCase();
    let itemBrand = data.vendor.toLowerCase();
    let itemCategory = '';
    let itemSize = data.variant_options.length ? data.variant_options[1] : '';
    let itemColor = data.variant_options.length ? data.variant_options[0] : '';
    let thisItemData;
    let itemProductType;
    let collectionOrigin = '';
    $.getJSON(fetchPath + '.js', (product) => {    
    }).done(function( data ) {
        const productData = data;
        let tagProductType;
        let tagProductCategory;
        let tagProductSubCategory;
        let itemTagCategory;
        let itemTagSubCategory;
        let itemTagProductType;
        const itemPrice = productData.price ? (productData.price/100).toFixed(2) : '';
        const firstAvailableVariant = productData.variants.filter(obj => {
            return obj.available === true
        })
        const collectionTitleEl = document.querySelector('.collection__header .section-header__title');
        collectionOrigin = collectionTitleEl?.innerText?.toLowerCase() || '';
        const listValue = 'plp-' + collectionOrigin;
        let finalListValue;

        if (collectionOrigin.length>0) {
            finalListValue = {
                list: listValue
            }
        }

        if (typeof productData.tags !== 'string') {
            tagProductType = productData.tags.filter(item => {
                return item.includes('Product Type_');
            });
            if (typeof tagProductType != 'undefined' && tagProductType.length>0 && tagProductType[0].includes('Product Type_')) itemTagProductType = tagProductType[0].replace('Product Type_','');
            tagProductCategory = productData.tags.filter(item => {
                return item.includes('Category_');
            });
            if (typeof tagProductCategory != 'undefined' && tagProductCategory.length>0 && tagProductCategory[0].includes('Category_')) itemTagCategory = tagProductCategory[0].replace('Category_','');
            tagProductSubCategory = productData.tags.filter(item => {
                return item.includes('Sub Category_');
            });
            if (typeof tagProductSubCategory != 'undefined' && tagProductSubCategory.length>0 && tagProductSubCategory[0].includes('Sub Category_','')) itemTagSubCategory = tagProductSubCategory[0].replace('Sub Category_','');
            if (typeof itemTagProductType != 'undefined' && itemTagProductType.length>0) {
                itemCategory += itemTagProductType + ' / ';
            }
            if (typeof itemTagCategory != 'undefined' && itemTagCategory.length>0) {
                itemCategory += itemTagCategory + ' / ';
            }
            if (typeof itemTagSubCategory != 'undefined' && itemTagSubCategory.length>0) {
                itemCategory += itemTagSubCategory;
            }
        }
      	itemCategory = itemCategory.toLowerCase();
        //itemName = productData.title.toLowerCase();
        //itemSku = firstAvailableVariant[0].sku.toLowerCase();
        //itemBrand = productData.vendor.toLowerCase();
        //itemSize = firstAvailableVariant[0].option2.toLowerCase();
        //itemColor = firstAvailableVariant[0].option1.toLowerCase();
        
        thisItemData = {
            'name': itemName,
            'id': itemSku,
            'price': itemPrice,
            'brand': itemBrand,
            'category': itemCategory,
            'variant': itemSize,
            'quantity': 1,
            'position': 1,
            'dimension2': itemColor
        }

        let thisItemObj;

        if (collectionOrigin.length>0) {
            thisItemObj = {
                event: 'addToCart',
                uaCategory: 'product page', // event location
                uaAction: 'add to cart',
                uaLabel: listValue, //original list name
                ecommerce: {
                    currencyCode: 'CAD',
                    add: {
                        actionField: finalListValue,
                        products: [thisItemData]
                    }
                }
            }
        } else {
            thisItemObj = {
                event: 'addToCart',
                uaCategory: 'product page', // event location
                uaAction: 'add to cart',
                // uaLabel: 'plp-sweatshirts', //original list name
                ecommerce: {
                    currencyCode: 'CAD',
                    add: {
                        products: [thisItemData]
                    }
                }
            }
        }
        dataLayer.push(thisItemObj)
    });
}

// Cart Product quanity update - send product data to GTM

// Notes:
// Product tags are not available in cart data so we cannot pass the category
// Adding another get request for Retrieving product tags is possible not recommended for performance reasons

const sendUpdatedQtyDataToGTM = (line, data, plusOrMinus) => {
    const itemLineOrder = line - 1;
    const cartItems = data.items;
    const itemThatChanged = data.items[itemLineOrder];
    let itemCategory = '';
    // console.log('itemThatChanged :', itemThatChanged);
    const productData = itemThatChanged;
    if(productData != undefined){
      const itemSku = productData.sku.toLowerCase();
      const itemBrand = productData.vendor.toLowerCase();
      const itemSize = productData.variant_options[1].toLowerCase();
      const itemColor = productData.variant_options[0].toLowerCase();
      const itemQty = productData.quantity;
    
    // if(productData.product_type != undefined){
	//  const itemCategory = productData.product_type;
    // }else{
    //  const itemCategory = '';
    // }
    // console.log('productPath: ', productPath);
    const fetchPath = '/products/' + productData.handle;
    // console.log('itemPath: ', itemPath);
    // console.log('editedItemPath: ', editedItemPath);
    $.getJSON(fetchPath + '.js', (product) => {
    }).done(function( data ) {
//       console.log(data);
        let itemPrice = data.price && typeof data.price === 'number' ? (data.price / 100).toFixed(2) : '';
        const productOptions = data.options_with_values;
        

        if (typeof data.tags !== 'string') {
            tagProductType = data.tags.filter(item => {
                return item.includes('Product Type_');
            });
            if (typeof tagProductType != 'undefined' && tagProductType.length>0 && tagProductType[0].includes('Product Type_')) itemTagProductType = tagProductType[0].replace('Product Type_','');
            tagProductCategory = data.tags.filter(item => {
                return item.includes('Category_');
            });
            if (typeof tagProductCategory != 'undefined' && tagProductCategory.length>0 && tagProductCategory[0].includes('Category_')) itemTagCategory = tagProductCategory[0].replace('Category_','');
            tagProductSubCategory = data.tags.filter(item => {
                return item.includes('Sub Category_');
            });
            if (typeof tagProductSubCategory != 'undefined' && tagProductSubCategory.length>0 && tagProductSubCategory[0].includes('Sub Category_','')) itemTagSubCategory = tagProductSubCategory[0].replace('Sub Category_','');
            if (typeof itemTagProductType != 'undefined' && itemTagProductType.length>0) {
                itemCategory += itemTagProductType + ' / ';
            }
            if (typeof itemTagCategory != 'undefined' && itemTagCategory.length>0) {
                itemCategory += itemTagCategory + ' / ';
            }
            if (typeof itemTagSubCategory != 'undefined' && itemTagSubCategory.length>0) {
                itemCategory += itemTagSubCategory;
            }
        }
        itemCategory = itemCategory.toLowerCase();
        itemName = data.title.toLowerCase();
        // console.log('data: ', data);
    
        const thisItemData = {
            'name': itemName,
            'id': itemSku,
            'price': itemPrice,
            'brand': itemBrand,
            'category': itemCategory,
            'variant': itemSize, // size
            'quantity': itemQty,
            'position': line,
            'dimension2': itemColor // color
        }
    
        // console.log('thisItemData: ', thisItemData);
        let dataLayerObj = {
            event: 'addToCart',
            uaCategory: 'quick view', // event location
            uaAction: 'add to cart',
            // uaLabel: 'plp-sweatshirts', //original list name - would be really inefficient to retrieve tis
            ecommerce: {
                currencyCode: 'CAD',
                add: {
                    products: [thisItemData]
                }
            }
        }

        // console.log('plusOrMinus: ', plusOrMinus);
        
        if (typeof plusOrMinus === 'string' && plusOrMinus.includes('minus')) {
            dataLayerObj = {
              event: 'removeFromCart',
              uaCategory: 'quick view', // event location
              uaAction: 'remove from cart',
              // uaLabel: 'plp-sweatshirts', //original list name - would be really inefficient to retrieve tis
              ecommerce: {
                  currencyCode: 'CAD',
                  remove: {
                      products: [thisItemData]
                  }
              }
            }
        }
        // console.log('dataLayerObj: ', dataLayerObj);
    
        dataLayer.push(dataLayerObj);   
    })
    }
}
